export default __webpack_public_path__ + "static/liberace_mood-f01232a10deacd3c44720cd251915e92.png";